import script from "./TableExpandable.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./TableExpandable.vue?vue&type=script&setup=true&lang=ts&generic=T"

import "./TableExpandable.vue?vue&type=style&index=0&id=fa4ca638&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa4ca638"]])

export default __exports__